import { useState } from 'react';
import { GuestLogCard } from '@/components/guests/GuestLogCard';
import { ActionCard } from '@/components/ui/ActionCard';
import {
  UsersIcon,
  UsersThreeIcon,
  DownloadSimpleIcon,
  NewspaperClippingIcon,
  ShieldCheckIcon,
} from '@phosphor-icons/react';
import { useNavigate } from '@tanstack/react-router';
import { ExportEventsDialog } from '@/components/events/ExportEventsDialog';
import { ExportGuestLogDialog } from '@/components/guests/ExportGuestLogDialog';
import { ExportUsersDialog } from '@/components/admin/ExportUsersDialog';
import { AdminContent } from '@/content/AdminContent';

export function Admin() {
  const navigate = useNavigate();
  const [isExportEventsDialogOpen, setIsExportEventsDialogOpen] =
    useState(false);
  const [isExportGuestsDialogOpen, setIsExportGuestsDialogOpen] =
    useState(false);
  const [isExportUsersDialogOpen, setIsExportUsersDialogOpen] = useState(false);

  return (
    <div className="flex justify-center items-start flex-col px-4 pb-4 mt-[34px] gap-2 max-w-4xl mx-auto w-full">
      <h1 className="font-field-74 text-h1 text-slate-50">Admin</h1>

      <div className="w-full mt-4">
        <h2 className="font-field-74 text-h3 text-purple-300 mb-2">
          Users and Guests
        </h2>
        <div className="flex flex-col gap-2">
          <ActionCard
            title="Manage Users"
            icon={UsersIcon}
            onClickAction={() => navigate({ to: '/admin/manage-users' })}
          />
          <ActionCard
            title="Manage Groups"
            icon={UsersThreeIcon}
            onClickAction={() => navigate({ to: '/admin/manage-groups' })}
          />
          <ActionCard
            title="Manage Roles"
            icon={ShieldCheckIcon}
            onClickAction={() => navigate({ to: '/admin/manage-roles' })}
          />
          <GuestLogCard />
        </div>
      </div>

      {/* Content Moderation Section */}
      <div className="w-full mt-4">
        <h2 className="font-field-74 text-h3 text-purple-300 mb-2">
          Content Moderation
        </h2>
        <div className="flex flex-col gap-2">
          <ActionCard
            title="Posts Pending Approval"
            icon={NewspaperClippingIcon}
            onClickAction={() => navigate({ to: '/admin/moderate-posts' })}
          />
        </div>
      </div>

      {/* Exports Section */}
      <div className="w-full mt-4">
        <h2 className="font-field-74 text-h3 text-purple-300 mb-2">
          {AdminContent.exports.sectionTitle}
        </h2>
        <div className="flex flex-col gap-2">
          <ActionCard
            title={AdminContent.exports.exportEvents.label}
            icon={DownloadSimpleIcon}
            onClickAction={() => setIsExportEventsDialogOpen(true)}
          />
          <ActionCard
            title={AdminContent.exports.exportUsers.label}
            icon={DownloadSimpleIcon}
            onClickAction={() => setIsExportUsersDialogOpen(true)}
          />
          <ActionCard
            title={AdminContent.exports.exportGuests.label}
            icon={DownloadSimpleIcon}
            onClickAction={() => setIsExportGuestsDialogOpen(true)}
          />
        </div>
      </div>

      {/* Export Dialogs */}
      <ExportEventsDialog
        open={isExportEventsDialogOpen}
        onOpenChange={setIsExportEventsDialogOpen}
      />
      <ExportGuestLogDialog
        open={isExportGuestsDialogOpen}
        onOpenChange={setIsExportGuestsDialogOpen}
      />
      <ExportUsersDialog
        open={isExportUsersDialogOpen}
        onOpenChange={setIsExportUsersDialogOpen}
      />
    </div>
  );
}
